"use client";

import { useEffect } from "react";

import { trackMovie } from "@/lib/analytics";

interface MovieViewTrackerProps {
  movieId: string;
  movieTitle: string;
}

/**
 * Tracks when a movie page is viewed
 * Must be a client component to run useEffect
 */
export function MovieViewTracker({
  movieId,
  movieTitle,
}: MovieViewTrackerProps) {
  useEffect(() => {
    trackMovie.viewed(movieId, movieTitle);
  }, [movieId, movieTitle]);

  return null;
}
